module.exports = __webpack_public_path__ + "static/media/filled-crown.4a3f0099.svg";